import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Logo from 'assets/images/icons/letrus-logo.webp';
import PageLoading from 'components/PageLoading';
import {Modal} from 'components/ui';
import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  accessUserRequest,
  getUserAccessError,
  isLoadingUserAccess,
} from 'store/reducers/authentication';
import {ApplicationState} from 'store/rootReducer';
import {useMobile, usePrevious, useQueryParam} from 'utils/hooks';
import styles from './access.module.scss';

interface StateProps {
  isLoadingUserAccess: boolean;
  userAccessError: boolean;
}

interface DispatchProps {
  accessUserRequest: typeof accessUserRequest;
}

enum MobileStoreURLs {
  playStore = 'https://play.google.com/store/apps/details?id=com.letrus',
  appStore = 'https://apps.apple.com/br/app/letrus/id1513215353',
}

type AccessPageProps = DispatchProps & StateProps;

function AccessPage({
  accessUserRequest,
  isLoadingUserAccess,
  userAccessError,
}: AccessPageProps): JSX.Element {
  const [isUserAccessErrorModalOpen, setIsUserAccessErrorModalOpen] =
    useState(false);
  const params = useQueryParam();
  const navigate = useNavigate();
  const previousIsLoadingUserAccess = usePrevious<boolean>(isLoadingUserAccess);
  const {isMobile, isIos, isAndroid} = useMobile();
  const token = params.get('token');

  if (!token) {
    navigate('/login');
    return <></>;
  }

  useEffect(() => {
    if (!isMobile) {
      accessUserRequest({token});
    }
  }, []);

  useEffect(() => {
    if (
      previousIsLoadingUserAccess &&
      !isLoadingUserAccess &&
      !userAccessError
    ) {
      navigate('/aceite_termos');
      sessionStorage.setItem('externalAPILogin', 'true');
    }

    if (
      previousIsLoadingUserAccess &&
      !isLoadingUserAccess &&
      userAccessError
    ) {
      setIsUserAccessErrorModalOpen(true);
    }
  }, [previousIsLoadingUserAccess, isLoadingUserAccess, userAccessError]);

  function getMobileStoreURL() {
    if (isIos) {
      return MobileStoreURLs.appStore;
    }

    if (isAndroid) {
      return MobileStoreURLs.playStore;
    }

    return '';
  }

  return isMobile ? (
    <>
      {isLoadingUserAccess ? (
        <PageLoading />
      ) : (
        <div className={styles.wrapper}>
          <img src={Logo} alt="Letrus" aria-hidden className={styles.logo} />
          <h2 className={styles.title}>
            A experiência na Letrus pode ser ainda melhor utilizando nosso
            aplicativo, sabia?
          </h2>
          <p className={styles.text}>
            Acesse agora e aproveite tudo que preparamos especialmente para
            você!
          </p>
          <a className={styles.deepLink} href={`letrus://login/${token}`}>
            Abrir aplicativo
          </a>
          <a className={styles.deepLink} href={getMobileStoreURL()}>
            Instalar aplicativo
          </a>
          <button
            type="button"
            className={styles.webLoginButton}
            onClick={() => accessUserRequest({token})}
          >
            Não, obrigado
          </button>

          <Modal
            isOpen={isUserAccessErrorModalOpen}
            onClose={() => setIsUserAccessErrorModalOpen(false)}
            title="Acesso via API"
            clickOutsideToClose
            vh={50}
            vw={90}
            buttonClose
          >
            <div className={styles.userAccessErrorModalWrapper}>
              <FontAwesomeIcon icon={['fas', 'key']} size="4x" />

              <div>
                <p>Código de acesso inválido.</p>

                <p>
                  Por favor, verifique a chave de acesso ou entre em contato com
                  um responsável da Letrus.
                </p>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  ) : (
    <PageLoading />
  );
}

export default connect(
  (state: ApplicationState) => ({
    isLoadingUserAccess: isLoadingUserAccess(state),
    userAccessError: getUserAccessError(state),
  }),
  {accessUserRequest},
)(AccessPage);
